import { Grid, Tab, Tabs } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { enabledFeatures } from 'config/env'
import { useTitle } from 'hooks'
import history from 'utils/history'
import { trackPageView } from 'utils/mixpanel'

import { redirectTo } from 'store/actions/user'
import { selectHasExecutePermissions } from 'store/selectors/user'

import UserChangeLogin from './components/UserChangeLogin'
import UserList from './components/UserList'
import UserManagePlan from './components/UserManagePlan'

const TABS = enabledFeatures.includes('SUBSCRIBER_INFO_DASHBOARD')
  ? [UserManagePlan, UserList, UserChangeLogin]
  : [UserChangeLogin]

const TabPanel = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {children}
    </div>
  )
}

const UserProfilePage = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const { tab } = useParams()

  const hasExecutePermissions = useSelector(selectHasExecutePermissions)

  const [activeTab, setActiveTab] = useState(0)

  const gotoTab = tab => {
    history.push(`/user-profile/${tab}`)
  }

  const onTabChange = (e, newValue) => {
    gotoTab(TABS[newValue].tabPath)
  }

  useTitle(t => t.user.profile.changeLogin)

  useEffect(() => {
    trackPageView()
  }, [])

  useEffect(() => {
    if (!hasExecutePermissions) {
      dispatch(redirectTo('/search', { replace: true }))
    }
  }, [hasExecutePermissions])

  useEffect(() => {
    const tabIndex = TABS.findIndex(tabComponent => tabComponent.tabPath === tab)
    if (tabIndex === -1) {
      gotoTab(TABS[0].tabPath)
    } else {
      setActiveTab(tabIndex)
    }
  }, [tab])

  return (
    <div className="main user-profile">
      <h1>{t.user.profile.myAccount}</h1>
      <Grid container spacing={4}>
        <Tabs value={activeTab} onChange={onTabChange} orientation="vertical">
          {TABS.map(tabComponent => (
            <Tab key={tabComponent.tabPath} label={tabComponent.getTabName(t)} />
          ))}
        </Tabs>
        {TABS.map((TabComponent, index) => (
          <TabPanel key={TabComponent.tabPath} value={activeTab} index={index}>
            <TabComponent />
          </TabPanel>
        ))}
      </Grid>
    </div>
  )
}

export default UserProfilePage
